export const ERRORS = {
  READ: 'Cannot get record from indexdb',
  READ_ALL: 'Cannot get all record from indexdb',
  ADD: 'Cannot add item to indexdb',
  UPDATE: 'Cannot update item to indexdb',
  DELETE: 'Cannot delete item from indexdb',
};
